import * as qplsService from '../../../services/Qpls/qplsService'
import {gridsNames} from '../../../enums/gridsNames';
import * as gridActionsHelper from 'infrastructure/js/components/Grid/Utils/gridActionsHelper';
import DateTimeHelper from 'infrastructure/js/utils/dateTimeHelper';

const gridActions = gridActionsHelper.getGridActions(gridsNames.ADMINISTRATION_MAT_SETTINGS_QPLS_ACTIVITY_LOG, _fetchDataAction, _convertToRowData);

function _fetchDataAction(query) {
  return function(dispatch, getState) {
    return qplsService.fetchQplsActivityLog(query);
  }
}

function _convertToRowData(rows, serverTimeSeconds) {
  let items = rows.map((row) => {
    row.m_Time = DateTimeHelper.FormatDateObjectToRelativeTime(row.time, serverTimeSeconds);
    row.valueBeforeChange = row.valueBeforeChange ? row.valueBeforeChange.split('\n') : null;
    row.valueAfterChange = row.valueAfterChange ? row.valueAfterChange.split('\n') : null;
    return row;
  });

  return items;
}

export let actionTypes = gridActions.actionTypes, api = gridActions.apiActions, jsxActions = gridActions.jsxActions;
